// MysticAI Analytics - Firebase ready event tracker
const analytics = {
  _initialized: false,
  _queue: [],

  init() {
    if (typeof window !== 'undefined' && window.gtag) {
      this._initialized = true;
      this._queue.forEach(([event, params]) => window.gtag('event', event, params));
      this._queue = [];
    }
  },

  track(event, params = {}) {
    const payload = { ...params, timestamp: new Date().toISOString() };
    if (this._initialized && window.gtag) {
      window.gtag('event', event, payload);
    } else {
      this._queue.push([event, payload]);
      console.debug(`[Analytics] ${event}`, payload);
    }
  },

  // Pre-defined events
  install: () => analytics.track('install'),
  signup: (method) => analytics.track('signup', { method }),
  login: (method) => analytics.track('login', { method }),
  tarotStarted: (spread) => analytics.track('tarot_started', { spread_type: spread }),
  tarotCompleted: (spread) => analytics.track('tarot_completed', { spread_type: spread }),
  horoscopeOpened: (sign, period) => analytics.track('horoscope_opened', { sign, period }),
  compatibilityStarted: () => analytics.track('compatibility_started'),
  compatibilityCompleted: () => analytics.track('compatibility_completed'),
  natalChartCreated: () => analytics.track('natal_chart_created'),
  hybridAnalysisStarted: () => analytics.track('hybrid_analysis_started'),
  aiCoachStarted: (topic) => analytics.track('ai_coach_started', { topic }),
  subscriptionStarted: () => analytics.track('subscription_started'),
  subscriptionPurchased: (plan) => analytics.track('subscription_purchased', { plan }),
};

export default analytics;
